











import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { TableLayer } from '@/model/document2/page/surface/design/layer/tableLayer';
import { TableCellInfo } from '@/model/document2/page/surface/design/layer/table/tableCellInfo';
import { SVGPathData, SVGPathDataTransformer, SVGPathDataParser } from 'svg-pathdata';
import { UserAgentHelper } from '@/helper/userAgentHelper';

import { DebugHelper } from "@/helper/debugHelper";

@Component({
    components: {
    },
})
export default class TableLayerDrawer extends Vue
{
    @Prop() private layer!: TableLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;

    private get x() { return this.layer.x; }
    private get y() { return this.layer.y; }
    private get width() { return this.layer.width; }
    private get height() { return this.layer.height; }

    // セル情報
    private get cells()
    {
        var cells = new Array();

        var currentY = this.layer.y;
        for(var row = 0; row < this.layer.row; ++row)
        {
            var currentX = this.layer.x;

            var width = 0;
            var height = 0;
            for(var col = 0; col < this.layer.column; ++col)
            {
                // 情報取得
                var info = this.layer.getCellInfo(row, col);

                width = info.cellWidthNormalized * this.layer.width / 100;
                height = info.cellHeightNormalized * this.layer.height / 100;
                var strokeWidth = this.layer.strokeWidth;
                var strokeColor = this.layer.strokeColor;
                var cellColor = info.backgroundColor;
                cells.push({
                    x : currentX,
                    y : currentY,
                    width : width,
                    height : height,
                    strokeWidth : strokeWidth,
                    strokeColor : strokeColor,
                    cellColor : cellColor,
                    cellInfo : info,
                    row : row,
                    column : col
                });

                currentX += width;
            }
            currentY += height;
        }
        return cells;
    }

    // セルの上に来た
    private onMouseOver(row, column)
    {
        this.layer.touchedRow = row;
        this.layer.touchedColumn = column;
    }

    private get transform() : string
    {
        var transform = "";

        // オフセット
        transform += "translate(" + this.offsetX + " " + this.offsetY + "),";

        // スケール
        transform += "scale(" + this.scale + " " + this.scale + "),";

        // 回転を適用する
        transform += "translate(" + this.x + " " + this.y + "),";
        transform += "rotate(" + this.layer.rotate + "),";
        transform += "translate(" + (-this.x) + " " + (-this.y) + ")";

        return transform;
    }
}
